module.exports = __webpack_public_path__ + "img/teaser_traktor2.bbfd3e5a.jpg";